export default __webpack_public_path__ + "static/media/Snd3.d663ab4e.mp3";